// extracted by mini-css-extract-plugin
export default {"title":"PlaceHolder_title__jgUHj","text":"PlaceHolder_text__ON2A7"};